enum Country {
  Sweden,
  Norway,
  Finland,
}
export default Country
